"use client";

/**
 * BrandGroupGuardProvider
 *
 * Mounted inside the [slug] layout.  Its sole responsibility is to record
 * the installing slug in localStorage when the user first opens the app in
 * standalone mode from a slug page, or when the `appinstalled` event fires.
 *
 * O registro passa por `recordCustomerInstallSlug`, que ignora dispositivos de
 * administrador: um administrador que abre a pagina publica da propria marca
 * dentro do app instalado nao pode acabar travado fora de `/admin`.
 *
 * The actual navigation guard (history patch + redirect logic) lives in
 * RootBrandGroupGuard (app/layout.tsx) so it stays alive for every route,
 * including /admin and /login where the [slug] layout is NOT mounted.
 *
 * ADR-002, ADR-003.
 */

import { useEffect } from "react";
import { recordCustomerInstallSlug } from "../../../lib/brandGroupGuard";

interface BrandGroupGuardProviderProps {
  slug: string;
}

export function BrandGroupGuardProvider({ slug }: BrandGroupGuardProviderProps) {
  useEffect(() => {
    // Record the installing slug when the app is first opened in standalone
    // mode from this slug page and no slug has been stored yet.
    recordCustomerInstallSlug(slug);

    // Also capture the install moment (user taps "Add to Home Screen").
    function handleAppInstalled() {
      recordCustomerInstallSlug(slug, { force: true });
    }
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, [slug]);

  return null;
}
